export function getOrgRedeemSuccessRoute(
  isProfileComplete: boolean,
  opts: { isMobileWeb?: boolean } = {}
) {
  if (opts.isMobileWeb) {
    return "/redeem-success";
  }

  return isProfileComplete ? "/payment-success" : "/create-profile";
}
